import { dataStorage } from "../userStorage.js";
import { appVars, randomUUID } from "../utils.js";
const safeColor = (c) => {
  if (typeof c !== 'string' || !(c = c.trim())) return '';
  if (/[";<>]/.test(c)) return '';
  return c;
};

export function base({ icon = '', title = '', content = '', button = null, titleColor = '', contentColor = '', hideWhenReload = false }) {
  let btn = '';
  if (button) {
    let attributes = '';
    let classes = button.style === 'on' ? 'primary' : (button.style || '');

    if (button.callback) attributes += ` click-callback="${button.callback}"`;
    if (button.need_reconnect) attributes += ` click-need-reconnect="${button.need_reconnect}"`;
    if (button.link) attributes += ` click-link="${button.link}"`;
    
    if (button.list) { 
      let dataKey = randomUUID();
      dataStorage[dataKey] = button.list;
      attributes += ` callback-data-key="${dataKey}" click-callback="list"`;
    }

    if (button.deeplink) attributes += ` click-deeplink="${button.deeplink}"`;
    const btnBg = safeColor(button.background_color);
    const btnColor = safeColor(button.text_color);
    const btnStyle = (btnBg || btnColor)
      ? ` style="${[btnBg && `background-color: ${btnBg}`, btnColor && `color: ${btnColor}`].filter(Boolean).join('; ')}"`
      : '';
    btn = `<div class="user-card-button button ${classes}"${btnStyle}${attributes}>` +
      `${button.title || ''}</div>`;
  }

  const tColor = safeColor(titleColor);
  const cColor = safeColor(contentColor);
  const titleStyle = tColor ? ` style="color: ${tColor}"` : '';
  const contentStyle = cColor ? ` style="color: ${cColor}"` : '';
  const center = `<div class="user-card-center">` +
    `<div class="user-card-title"${titleStyle}>${title}</div>` +
    `<div class="user-card-content"${contentStyle}>${content}</div>` +
    `</div>`;
  return `<div class="user-card"${hideWhenReload ? ' data-hide-when-reload="true"' : ''}>` +
    `<div class="user-card-icon icon-${icon}"></div>` +
    center +
    btn +
    `</div>`;
}
